import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { PlayerMutationKeys } from '../../../keys'
import { CreatePlayerRequest, CreatePlayerResponse } from '../../../type'
import { createPlayer } from '../../services'

export default function useMutationCreatePlayer(
	props?: UseBaseMutationOptions<CreatePlayerResponse, CreatePlayerRequest>,
) {
	return useMutation({
		mutationKey: [PlayerMutationKeys.CreatePlayer],
		mutationFn: (params) => createPlayer(params),
		...props,
	})
}
